"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableColumnsDisplayGrid = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var globalTypes_1 = require("../../../gen-src/queries/globalTypes");
var NumberCellFormatter_1 = require("../datagrid/cellFormatters/NumberCellFormatter");
var QueryPreservingLinkCellFormatter_1 = require("../datagrid/cellFormatters/QueryPreservingLinkCellFormatter");
var RemoteTypeIcon_1 = require("../datagrid/cellFormatters/RemoteTypeIcon");
var TagCellFormatter_1 = require("../datagrid/cellFormatters/TagCellFormatter");
function columns(featureFlags) {
    var cols = [
        function () { return data_catalog_shared_1.createSelectionColumn(); },
        featureFlags.columnDQWs ? function () { return ({
            name: 'warning',
            dataKey: '',
            headerText: '',
            headerTooltip: Localize_1.Messages.DataQualityWarningTitle(),
            headerFormatter: data_catalog_shared_1.DataQualityIconHeaderFormatterFactory,
            cellFormatter: createColumnDataQualityCellFormatter({
                getWarningsFromRowData: function (r) { return r.__typename === 'Column' ? r.dataQualityWarnings : undefined; }
            }),
            sortable: false,
            resizable: false,
        }); } : false,
        function (sortParams) { return ({
            name: 'type',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: Localize_1.Messages.GridHeaderType(),
            headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
            cellFormatter: data_catalog_shared_1.createIconCellFormatter(function (_a) {
                var remoteType = _a.remoteType;
                return React.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: remoteType });
            }, function (_a) {
                var remoteType = _a.remoteType;
                return data_catalog_shared_1.RemoteTypeMappings[remoteType]();
            }),
            resizable: false,
            sortable: false,
        }); },
        function (sortParams) { return ({
            name: 'name',
            dataKey: globalTypes_1.ColumnOrderField.NAME,
            headerText: Localize_1.Messages.GridHeaderName(),
            headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
            cellFormatter: QueryPreservingLinkCellFormatter_1.createQueryPreservingReplacingLinkCellFormatter(function (_a) {
                var name = _a.name;
                return name || '';
            }, function (urls, _a) {
                var id = _a.id, tableId = _a.tableId;
                return urls.catalogTableColumnPath(tableId, id);
            }),
            resizable: true,
            sortable: true,
        }); },
        function (sortParams) { return ({
            name: 'connectedSheets',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: Localize_1.Messages.GridHeaderSheets(),
            headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams, 'right'),
            cellFormatter: NumberCellFormatter_1.createNumberCellFormatter(function (_a) {
                var sheetCount = _a.sheetCount;
                return sheetCount;
            }),
            sortable: false,
        }); },
        function (sortParams) { return ({
            name: 'connectedDatasources',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: Localize_1.Messages.GridHeaderDatasources(),
            headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams, 'right'),
            cellFormatter: NumberCellFormatter_1.createNumberCellFormatter(function (_a) {
                var datasourceCount = _a.datasourceCount;
                return datasourceCount;
            }),
            sortable: false,
        }); },
        function (sortParams) { return ({
            name: 'description',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: Localize_1.Messages.GridHeaderDescription(),
            headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
            cellFormatter: data_catalog_shared_1.createTextCellFormatter(function (_a) {
                var description = _a.description;
                return description;
            }, Localize_1.Messages.NoDescriptionGridPlaceholder()),
            sortable: false,
            growToFit: true,
        }); },
        function (sortParams) { return ({
            name: 'tags',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: Localize_1.Messages.GridHeaderTags(),
            headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
            cellFormatter: TagCellFormatter_1.createTagCellFormatter(function (_a) {
                var tags = _a.tags;
                return tags !== null && tags !== void 0 ? tags : [];
            }),
            sortable: false,
            growToFit: true
        }); },
    ];
    return cols.filter(Boolean);
}
function TableColumnsDisplayGrid(props) {
    var featureFlags = React.useContext(data_catalog_shared_1.FeatureFlagsContext);
    var cols = columns(featureFlags).map(function (columnFactory) { return columnFactory(props); });
    return (React.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.TableColumnsDisplayGrid = TableColumnsDisplayGrid;
var IconStyle = {
    position: 'relative',
    left: '13.4px',
    top: '2px'
};
function createColumnDataQualityCellFormatter(opts) {
    var getWarningsFromRowData = opts.getWarningsFromRowData, linksDisabled = opts.linksDisabled;
    return function (props) {
        var anchoredWarnings = getWarningsFromRowData(props.row.data);
        var warning = anchoredWarnings && anchoredWarnings[0] ? anchoredWarnings[0] : undefined;
        if (!warning) {
            return (React.createElement(React.Fragment, null));
        }
        return React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) { return (React.createElement("div", { style: IconStyle },
            React.createElement(data_catalog_shared_1.WarningStatusIcon, { iconOnly: true, kind: 'graph', upstreamWarnings: [], subjectArea: 'Column', anchoredAsset: warning, anchoredWarnings: anchoredWarnings !== null && anchoredWarnings !== void 0 ? anchoredWarnings : [], urls: linksDisabled ? undefined : urls, linksDisabled: linksDisabled }))); });
    };
}
//# sourceMappingURL=TableColumnsDisplayGrid.js.map